export function initCardGalleries(root, SwiperClass, modules = {}) {
    if (!root || typeof SwiperClass !== 'function') return [];

    const initialized = [];
    root.querySelectorAll('[data-card-gallery-main]').forEach((mainEl) => {
        if (mainEl.swiper || mainEl.dataset.swiperInited === '1') return;

        const slides = mainEl.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide');
        if (slides.length < 2) {
            mainEl.dataset.swiperInited = 'single';
            return;
        }

        const card = mainEl.closest('.wrapper-block-card') || mainEl.parentElement;
        const thumbsEl = card ? card.querySelector('[data-card-gallery-thumbs]') : null;
        let thumbsSwiper = null;

        if (thumbsEl && !thumbsEl.swiper) {
            thumbsSwiper = new SwiperClass(thumbsEl, {
                modules: modules.FreeMode ? [modules.FreeMode] : [],
                slidesPerView: 4,
                spaceBetween: 6,
                watchSlidesProgress: true,
                freeMode: true,
                breakpoints: {
                    768: { slidesPerView: 5, spaceBetween: 8 },
                    1024: { slidesPerView: 6, spaceBetween: 8 },
                },
            });
        } else if (thumbsEl) {
            thumbsSwiper = thumbsEl.swiper;
        }

        const options = {
            modules: [modules.Thumbs, modules.Pagination].filter(Boolean),
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            watchOverflow: true,
        };
        if (thumbsSwiper) options.thumbs = { swiper: thumbsSwiper };
        const paginationEl = mainEl.querySelector('[data-card-gallery-pagination]');
        if (paginationEl) options.pagination = { el: paginationEl, clickable: true };

        const mainSwiper = new SwiperClass(mainEl, options);
        mainEl.dataset.swiperInited = '1';
        initialized.push({ main: mainSwiper, thumbs: thumbsSwiper });
    });

    return initialized;
}

export function observeCardGalleries(root, SwiperClass, modules = {}) {
    if (!root || typeof MutationObserver === 'undefined') return null;

    const observer = new MutationObserver((mutations) => {
        if (mutations.some((mutation) => mutation.addedNodes.length > 0)) {
            initCardGalleries(root, SwiperClass, modules);
        }
    });
    observer.observe(root, { childList: true, subtree: true });
    return observer;
}
